<template>
<!-- 面包屑 -->
    <div class="break">
        <div v-for="(item,index) in info" :key="item.type">
            <router-link tag="p" :to="{name:item.component,params:{type:item.type}}" :class="active==item.type?'active':''">{{item.title}}</router-link>
            <span v-if="index !== info.length-1">/</span>
        </div>
    </div>
</template>
<script>
export default {
  name: 'BreakList',
  props:['info','active']
}
</script>
<style lang="scss" scoped>
    .break{
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #E5E5E5;
        div{
            display: flex;
            align-items: center;
        }
        p{
            padding: 20px 0 18px;
            border-bottom: 2px solid transparent;
            cursor: pointer;
            font-size: 20px;
            line-height: 26px;
        }
        .active{
            border-bottom: 2px solid #FAB51D;
        }
        span{
            color: #C0C4CC;
            margin: 0 16px;
        }
    }
    @media screen and (max-width: 1200px){
        .break{
            p{
                font-size: 16px;
            }
        }
    }
    @media screen and (max-width: 768px){
        .break{
            overflow: auto;
            div{
                flex-shrink: 0;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/BreadLink.vue